import React from 'react';
import { Menu, Dropdown, Button, Popconfirm } from 'antd';
import { CSVLink } from 'react-csv';
import exportFromJSON from 'export-from-json';
import { Container, Menus } from './styles';

import { TableOutlined } from '@ant-design/icons';

const ExportBtn: React.FC<any> = ({ onGetAllData, filename, screenData }) => {
  let data = '';
  const fileName = `${filename}`;
  const exportType = 'xls';

  async function fullTable() {
    data = await onGetAllData();
    exportFromJSON({ data, fileName, exportType });
  }

  function currentTable() {
    exportFromJSON({ data: screenData, fileName, exportType });
  }

  const menuDropDown = (
    <Menus>
      <Menu.Item>
        <Button type="link">
          <CSVLink type="link" data={data} filename={`${filename}.csv`}>
            CSV
          </CSVLink>
        </Button>
      </Menu.Item>
      <Menu.Item>
        <Popconfirm
          title="Exportar Tabela"
          okText="Atual"
          cancelText="Completa"
          placement="leftBottom"
          onConfirm={currentTable}
          onCancel={fullTable}
          icon={false}
        >
          <Button type="link">XLS(Excel)</Button>
        </Popconfirm>
      </Menu.Item>
    </Menus>
  );

  return (
    <Dropdown overlay={menuDropDown}>
      <Container
        className="outlineBtn"
        icon={<TableOutlined />}
        onClick={(e) => e.preventDefault()}
      >
        Exportar
      </Container>
    </Dropdown>
  );
};

export default ExportBtn;
